"use client"

import React from 'react'
import { Sun, Moon } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'
import { VisuallyHidden } from './ui/visually-hidden.jsx'

export function ThemeToggle({ className = '' }) {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'
  
  return (
    <button
      className={`icon-btn ${className}`}
      onClick={toggleTheme}
      aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
      aria-pressed={isDark}
      role="switch"
      title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
    >
      {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
      <VisuallyHidden>
        {isDark 
          ? 'Dark mode is currently active. Switch to light mode.'
          : 'Light mode is currently active. Switch to dark mode.'
        }
      </VisuallyHidden>
    </button>
  )
}